import useRepo from '@/nebula/repo';
import { EQ, RESULT, UID } from 'shared/api/query/constants';
import { customDatasourceProperty } from 'shared/constants.json';
import {
  dataSource as dataSourceConfig,
} from 'shared/api/query/configs.json';
import { ref } from 'vue';

export default function useAzureDevOpsDatasourceRepo() {
  const repo = useRepo(dataSourceConfig.model);

  const getProjectsInOrganizationLoading = ref(false);
  const getProjectsInOrganization = (entity) => {
    getProjectsInOrganizationLoading.value = true;
    return repo.query([{
      alias: RESULT,
      func: { name: UID },
      model: dataSourceConfig.model,
      uid: [entity.uid],
      children: [
        { attr: UID },
        { attr: customDatasourceProperty.dataSourceError, default: null },
        {
          attr: customDatasourceProperty.azureDevOpsProjects,
          filter: { func: { name: EQ, attr: customDatasourceProperty.azureDevOpsOrganizations, args: [{ value: entity[customDatasourceProperty.azureDevOpsOrganizations][0].id }] } },
        },
      ],
    }]).then(() => repo.selectSingle(entity.uid)).finally(() => {
      getProjectsInOrganizationLoading.value = false;
    });
  };

  return {
    getProjectsInOrganizationLoading,
    getProjectsInOrganization,
  };
}
